import Vue from 'vue'
import axios from 'axios'
import toastr from 'toastr'

import { DEFAULT_ERROR_MESSAGE } from 'src/common/constants'
import { searchParams } from 'src/common/search_params'
import { compileRanges, TIME_FORMAT } from 'src/common/datepicker'
import Widget from '../../vue_widgets/reports/show.vue'
import createInsightsStore from '../../vue_widgets/gmb/locations/insights/store'

const PER_PAGE_REPORTS = 10

function buildList(stringsArray) {
  const list = stringsArray.map((str) => `<li>${str}</li>`)
  return `<ul>${list.join()}</ul>`
}

function handleNotifyLinkClick(e) {
  e.preventDefault()
  $('.main-content').toggleWrapper()
  const url = $(e.currentTarget).attr('href')

  axios.post(url)
    .then((res) => {
      if (res.data.emails) {
        toastr.success(buildList(res.data.emails), res.data.msg)
      } else {
        toastr.warning(res.data.msg)
      }
    })
    .catch((error) => {
      toastr.error((error.response && error.response.data && error.response.data.msg) || DEFAULT_ERROR_MESSAGE)
    })
    .finally(() => $('.main-content').toggleWrapper({}, false))
}

export default function initReportsShow(params) {
  $(() => {
    $('.js-location-anchor').click((e) => {
      const index = Array.from(e.currentTarget.parentElement.children).indexOf(e.currentTarget)
      const currentPage = parseInt(searchParams().page || 1, PER_PAGE_REPORTS)
      const page = Math.floor(index / PER_PAGE_REPORTS) + 1

      if (page !== currentPage) {
        window.location.hash = e.currentTarget.hash
        window.location.search = `page=${page}`
      }
    })

    $('.js-insights-chart').each((_, el) => {
      const locationIds = el.getAttribute('data-location-ids')
      const enabledStats = params.properties[locationIds]
      let urlPath = params.reportPath
      if (locationIds && !locationIds.includes(',')) urlPath += `?location_ids=${locationIds}`

      const store = createInsightsStore({
        insightsExists: true,
        insightsPath: '',
        insightsCsvPath: '',
        compare: enabledStats && enabledStats.length > 0,
        enabledStats: enabledStats,
        httpParams: [urlPath, { headers: { Accept: 'application/json' } }],
        insightsDateRanges: {
          compare: true,
          ranges: compileRanges({
            currStart: moment.utc(params.start, TIME_FORMAT),
            currEnd: moment.utc(params.end, TIME_FORMAT),
            prevStart: moment.utc(params.compareStart, TIME_FORMAT),
            prevEnd: moment.utc(params.compareEnd, TIME_FORMAT)
          })
        }
      })

      // eslint-disable-next-line no-new
      new Vue({
        el: el,
        store: store,
        render: (h) => h(Widget)
      })
    })

    $('.js-action-notify').on('click', handleNotifyLinkClick)
  })
}
